import type { ValueOf } from 'type-fest';

export const RescheduleTourModalTriggers = {
  LEAD_MANAGEMENT: 'lead_management',
  SATELLITE: 'satellite',
  ZRM_TOUR_CALENDAR: 'zrm_tour_calendar',
} as const;

export type RescheduleTourModalTriggers = ValueOf<typeof RescheduleTourModalTriggers>;
